module.exports = __webpack_public_path__ + "static/media/page2_furba3.64a9eb7c.wav";